<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M102.559 59.3538C102.682 61.9847 103.525 78.9307 91.58 85.6591C80.2988 92.0143 50.467 89.2603 50.5118 84.2746C50.5566 79.4494 97.8158 76.77 102.357 86.0883C104.544 90.5701 101.79 94.5109 98.7413 97.2724"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M30.4052 24.1781C30.6365 17.7333 35.361 12.5163 41.455 11.4117L41.4624 11.2027C34.0287 10.934 27.7817 16.7444 27.5168 24.1781C27.2481 31.6118 33.0585 37.8588 40.4922 38.1237L40.5071 37.7058C34.5064 36.1645 30.1738 30.6191 30.4052 24.1781Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.8702 38.1349C51.3104 38.1349 57.3419 32.1034 57.3419 24.6632C57.3419 17.223 51.3104 11.1915 43.8702 11.1915C36.4299 11.1915 30.3984 17.223 30.3984 24.6632C30.3984 32.1034 36.4299 38.1349 43.8702 38.1349Z"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.8691 11.4565V16.054"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.8691 33.0448V37.6386"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.7773 24.5475H35.3749"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.3633 24.5475H56.9608"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.2616 15.8711L43.8691 24.6632L47.7987 30.4586"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.0996 69.1125C78.1406 68.6758 76.9688 67.9631 76.8643 66.9144C76.7225 65.4964 78.663 64.6604 79.0996 63.108C79.3758 62.1303 79.0996 60.716 76.5098 58.8762"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M81.1916 67.4518C80.9154 67.0376 80.6131 66.4219 80.7176 65.7278C80.8445 64.9068 81.4528 64.5821 81.7215 63.9999C82.0312 63.3245 81.9342 62.1826 80.1504 60.1338"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.3833 72.8666H73.8222C73.6132 72.8666 73.4453 72.6987 73.4453 72.4897V71.1985C73.4453 70.9896 73.6132 70.8216 73.8222 70.8216H85.3833C85.5922 70.8216 85.7602 70.9896 85.7602 71.1985V72.4897C85.7602 72.6987 85.5922 72.8666 85.3833 72.8666Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.5329 75.3893L74.2344 72.8741H84.9894L84.0191 80.8862"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M84.0667 80.4944L83.6301 84.0881C83.604 84.3008 83.4211 84.4613 83.2084 84.4613H75.98C75.7635 84.4613 75.5844 84.3008 75.5583 84.0844L75.3008 81.6774"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M81.9835 80.4235H74.7812L74.1953 75.4042H82.7635"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M34.1671 103.993C34.1671 103.993 25.9647 117.439 26.2371 117.439H29.3345L38.9289 104.9"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M86.4317 103.993C86.4317 103.993 94.6341 117.439 94.3617 117.439C91.7196 117.439 91.2643 117.439 91.2643 117.439L81.6699 104.9"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M97.4593 99.463C97.4593 99.463 105.662 109.36 105.389 109.36H102.292L93.9141 100.9"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M97.7537 98.1681C86.4202 107.706 62.6712 106.053 41.7658 104.923C25.2079 104.027 20.2745 96.5671 23.6965 86.8123C24.4503 84.6628 25.5475 82.6513 26.8909 80.8116C29.171 77.6843 33.9029 72.8368 42.5308 64.5298C53.7112 53.7636 53.1067 37.4185 68.1084 30.2534C91.4283 19.1178 99.1195 48.3414 99.1195 48.3414"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M54.8848 58.7493C55.2169 56.7491 58.0418 41.1913 70.5023 35.937C72.3681 35.1496 74.8834 34.4107 78.0554 34.2763"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.918 77.8374C48.1275 76.1954 54.7141 74.6691 62.4016 74.1355C63.8906 74.031 65.3422 73.9713 66.7603 73.9451"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
